import React from 'react';
import { styled, StyledProps } from '@glitz/react';
import { RatioPicture, Ratio as ImageRatio, Preset } from 'Shared/Image/Ratio';
import Price from 'Pricing/Price';
import ProductListItemViewModel from '../../Product/ProductListing/ProductListItemViewModel.type';
import Link from 'Shared/Generic/A';
import { Text, TextBlock, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import { colorFromTag } from 'Shared/utils';
import * as style from 'Shared/Style';

type PropType = StyledProps & {
  product: ProductListItemViewModel;
  isMobile: boolean;
  onTracking?: () => void;
};

const CardWrap = styled(Link, {
  display: 'flex',
  marginBottom: 12,
  color: style.colors.monochrome.black,
  ':hover': {
    textDecoration: 'none',
  }
});

const Media = styled.div({
  flexBasis: '98px',
});

const Content = styled.div({
  margin: { xy: 8 },
  position: 'relative',
  fontSize: '14px',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

const DisplayName = styled.div({
  display: 'block',
  textTransform: 'uppercase',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '100%',
});

const Tags = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px'
})

const Item = (props: PropType) => {
  const {
    isMobile,
    product,
  } = props;

  return (
    <CardWrap
      css={props.compose()}
      draggable="false"
      to={product.url}
      linkIdentifier={product.ticket}
      onClick={props.onTracking}
    >
      <Media>
        <RatioPicture
          src={product.imageUrls[0]}
          alt={product.displayName}
          ratio={ImageRatio.ThreeToFour}
          preset={Preset.ItemThumbLarge}
          borderRadius={8}
        />
      </Media>
      <Content>
        <DisplayName>{product.displayName}</DisplayName>
        <TextBlock css={{ fontWeight: isMobile ? 500 : 450 }} fontSize={ResponsiveSize.D14_M14_L130}>
          {product.oneLineText}
        </TextBlock>
        <Tags>
          {product.tags &&
            product.tags.slice(0, 2).map((tag, index) => (
              <Text
                upperCase
                fontSize={ResponsiveSize.D12_M12}
                key={index}
                css={{ color: colorFromTag(tag.code, tag.color) }}
              >
                {tag.tag}
              </Text>
            ))}
        </Tags>
        <Price
          css={{ marginTop: '2px' }}
          {...product.price}
          fontSize={14}
          fontSizePrevPrice={12}
        />
      </Content>
    </CardWrap>
  );
};

export default styled(Item, {
  marginBottom: '10px',
});
